import React from "react";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { translate } from "react-switch-lang";

function RegionCard({
  t,
  regions,
  regionValue,
  regionOpen,
  setRegionOpen,
  onCardChange,
  dropdownDirection,
}) {
  // Handle toggle using raw region value
  const _regionValue = [...regionValue];
  const toggleItem = (item) => {
    // Normalize for consistent comparison (case-insensitive, trimmed)
    const normalize = (str) => str.toLowerCase().trim();

    const normalizedItem = normalize(item);
    const updated = regionValue.some((val) => normalize(val) === normalizedItem)
      ? regionValue.filter((val) => normalize(val) !== normalizedItem)
      : [...regionValue, item];

    onCardChange(updated);
  };

  // Map raw regions to { label, raw } objects
  const translatedRegions = regions.map((r) => ({
    label: t("regions." + r),
    raw: r,
  }));

  const renderTitle = () => {
    if (regionValue.length === 0) return `📍 ${t("regions.Placeholder")}`;
    if (regionValue.length === 1) return `📍 ${t("regions." + regionValue[0])}`;
    return `📍 ${t("regions.Title")}: ${t("common.Selected")} ${regionValue.length}`;
  };

  return (
    <Dropdown
      show={regionOpen}
      drop={dropdownDirection}
      onToggle={(isOpen) => setRegionOpen(isOpen)}
      className="filter-pill w-100"
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-toggle-pill w-100 text-start"
      >
        {renderTitle()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {translatedRegions.map((region) => (
          <Dropdown.Item
            key={region.raw}
            as="button"
            className="d-flex align-items-center"
            onClick={() => {
              toggleItem(region.raw);
            }}
          >
            <input
              type="checkbox"
              className="me-2 mr-2"
              readOnly
              checked={_regionValue
                .map((s) => s.toLowerCase())
                .includes(region.raw.toLowerCase())}
            />
            {region.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

RegionCard.propTypes = {
  t: PropTypes.func.isRequired,
  regions: PropTypes.array.isRequired,
  regionValue: PropTypes.array.isRequired,
  regionOpen: PropTypes.bool.isRequired,
  setRegionOpen: PropTypes.func.isRequired,
  onCardChange: PropTypes.func.isRequired,
  dropdownDirection: PropTypes.string,
};

RegionCard.defaultProps = {
  dropdownDirection: "down",
};
const TranslateRegionCard = translate(RegionCard);
export default TranslateRegionCard;
